import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	actions: {
		id: 'servicedesk.common.i18n.actions',
		defaultMessage: 'Actions',
		description: '',
	},
	add: {
		id: 'servicedesk.common.i18n.add',
		defaultMessage: 'Add',
		description: '',
	},
	genericErrorTitle: {
		id: 'servicedesk.common.i18n.ran-into-problem',
		defaultMessage: 'We ran into a problem',
		description: '',
	},
	offlineTitle: {
		id: 'servicedesk.common.i18n.offline-title',
		defaultMessage: 'Looks like you’re offline',
		description: '',
	},
	offlineMessage: {
		id: 'servicedesk.common.i18n.offline-message',
		defaultMessage: 'Check your connection and try again',
		description: '',
	},
	automation: {
		id: 'servicedesk.common.i18n.automation',
		defaultMessage: 'Automation',
		description: '',
	},
	answer: {
		id: 'servicedesk.common.i18n.answer',
		defaultMessage: 'Answer',
		description: 'Name for the answer object (short form text) in JSM Knowledge Hub.',
	},
	cancel: {
		id: 'servicedesk.common.i18n.cancel',
		defaultMessage: 'Cancel',
		description: '',
	},
	close: {
		id: 'servicedesk.common.i18n.close',
		defaultMessage: 'Close',
		description: 'Message to be displayed on a close button.',
	},
	configuration: {
		id: 'servicedesk.common.i18n.configuration',
		defaultMessage: 'Configuration',
		description: '',
	},
	continue: {
		id: 'servicedesk.common.i18n.continue',
		defaultMessage: 'Continue',
		description: '',
	},
	create: {
		id: 'servicedesk.common.i18n.create',
		defaultMessage: 'Create',
		description: 'Text used in context of creating something.',
	},
	date: {
		id: 'servicedesk.common.i18n.date',
		defaultMessage: 'Date',
		description: '',
	},
	delete: {
		id: 'servicedesk.common.i18n.delete',
		defaultMessage: 'Delete',
		description: '',
	},
	disabled: {
		id: 'servicedesk.common.i18n.disabled',
		defaultMessage: 'Disabled',
		description: '',
	},
	discard: {
		id: 'servicedesk.common.i18n.discard',
		defaultMessage: 'Discard',
		description: '',
	},
	duplicate: {
		id: 'servicedesk.common.i18n.duplicate',
		defaultMessage: 'Duplicate',
		description: '',
	},
	edit: {
		id: 'servicedesk.common.i18n.edit',
		defaultMessage: 'Edit',
		description: '',
	},
	error: {
		id: 'servicedesk.common.i18n.error',
		defaultMessage: 'Error',
		description: '',
	},
	executed: {
		id: 'servicedesk.common.i18n.executed',
		defaultMessage: 'Executed',
		description: '',
	},
	issue: {
		id: 'servicedesk.common.i18n.issue',
		defaultMessage: 'Issue',
		description: '',
	},
	next: {
		id: 'servicedesk.common.i18n.next',
		defaultMessage: 'Next',
		description: '',
	},
	notExecuted: {
		id: 'servicedesk.common.i18n.not-executed',
		defaultMessage: 'Not Executed',
		description: '',
	},
	options: {
		id: 'servicedesk.common.i18n.options',
		defaultMessage: 'Options',
		description: '',
	},
	preference: {
		id: 'servicedesk.common.i18n.preference',
		defaultMessage: 'Preference',
		description: '',
	},
	save: {
		id: 'servicedesk.common.i18n.save',
		defaultMessage: 'Save',
		description: '',
	},
	status: {
		id: 'servicedesk.common.i18n.status',
		defaultMessage: 'Status',
		description: '',
	},
	undo: {
		id: 'servicedesk.common.i18n.undo',
		defaultMessage: 'Undo',
		description: '',
	},
	unknown: {
		id: 'servicedesk.common.i18n.unknown',
		defaultMessage: 'Unknown',
		description: '',
	},
	warning: {
		id: 'servicedesk.common.i18n.warning',
		defaultMessage: 'Warning',
		description: '',
	},
	settings: {
		id: 'servicedesk.common.i18n.settings',
		defaultMessage: 'Settings',
		description: '',
	},
});
